import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types' // Make sure your PageMeta type includes an optional `keywords` string property

// This is now packed with your inspirations
export const DEFAULT_META: PageMeta = {
  title: 'The NEX | A Sci-Fi Extraction RPG Metaverse',
  description:
    'Inspired by Ready Player One, The Matrix, Tarkov, and Halo, The NEX is a free-to-play blockchain MMO where your loot is truly yours. Experience the next evolution of gaming.',
  image: 'https://hub.thenex.world/images/hero.png',
  keywords: 'The NEX, metaverse, Ready Player One, The Matrix, World of Warcraft, Cyberpunk, RuneScape, Tarkov, Dark & Darker, Halo 3, Ghosts of Tabor, extraction shooter, blockchain MMO, NFT game, play and earn',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath;
  // No changes to this part
  // if (path.startsWith('/swap')) {
  //   basePath = '/swap'
  // } else if (path.startsWith('/add')) {
  //   basePath = '/add'
  // } else if (path.startsWith('/remove')) {
  //   basePath = '/remove'
  // } else if (path.startsWith('/teams')) {
  //   basePath = '/teams'
  // } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
  //   basePath = '/voting/proposal'
  // } else if (path.startsWith('/nfts/collections')) {
  //   basePath = '/nfts/collections'
  // } else if (path.startsWith('/nfts/profile')) {
  //   basePath = '/nfts/profile'
  // } else if (path.startsWith('/pancake-squad')) {
  //   basePath = '/pancake-squad'
  // } else {
    basePath = path;
  // }

  switch (basePath) {
    case '/':
      return {
        title: t('The NEX: Sci-Fi Extraction RPG | Blockchain Looter Shooter'),
        description: t('A free-to-play metaverse inspired by Halo, Tarkov, & Dark & Darker, with the true asset ownership that WoW & RuneScape lack. Your legend has real value.'),
        image: 'https://hub.thenex.world/images/hero.png',
        keywords: 'The NEX, extraction shooter, looter shooter, blockchain MMO, NFT game, play and earn, Tarkov, Dark and Darker, Halo, sci-fi RPG, PvPvE, web3 gaming, World of Warcraft, RuneScape',
      }
    case '/glitch':
      return {
        title: t('Mint a GLITCH NFT | Limited Edition Boss Monster for The NEX Metaverse'),
        description: t(
          'Mint a legendary GLITCH boss monster for The NEX metaverse. Gain exclusive in-game utility, permanent XP boosts, and access to the Corrupted Lair. Limited supply available!',
        ),
        image: 'https://hub.thenex.world/images/glitch/glitchNFT.gif',
        keywords: 'The NEX, extraction shooter, looter shooter, blockchain MMO, NFT game, play and earn, Tarkov, Dark and Darker, Halo, sci-fi RPG, PvPvE, web3 gaming, World of Warcraft, RuneScape'
      }
    case '/xp':
      return {
        title: t('Buy XP Token | The In-Game Currency for Minting & Gaming in The NEX'),
        description: t(
          'Acquire XP, the essential utility token for The NEX. Use XP to mint exclusive NFTs, unlock in-game content, boost rewards, and participate in the ecosystem.',
        ),
        image: 'https://hub.thenex.world/images/xp.jpg',
        keywords: 'The NEX, extraction shooter, looter shooter, blockchain MMO, NFT game, play and earn, Tarkov, Dark and Darker, Halo, sci-fi RPG, PvPvE, web3 gaming, World of Warcraft, RuneScape',
      }
    case '/glitch-contest':
      return {
        title: t('The GLITCH Hunter Contest: Win a Share of a $25,000+ Prize Pool | The NEX'),
        description: t('Join the hunt in The NEX\'s GLITCH Hunter Contest! Kill in-game bosses for a chance to win from a community-unlocked $25,000+ prize pool of NFTs and $XP tokens. Compete now!'),
        image: 'https://hub.thenex.world/images/hero.png', 
        keywords: 'NFT gaming contest, play to earn event, crypto game giveaway, win NFT, $25,000 prize pool, The NEX contest, GLITCH hunter contest, blockchain game competition, extraction shooter event, web3 gaming rewards',
      }
    default:
      return null
  }
}